const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { accordion } = require("./modules/accordion");
const { anchor } = require("./modules/anchor");
const { shop } = require("./modules/shop");

scrollmagic();
pageTop();
smooth();
accordion();
anchor();
shop();